<template>
    <div id="page" :class="'page-wrap skin-'+sext[0]">
        <!-- sx-{{sxi}}-{{sex}}-{{sxy}} -->
        <div class="sx-head pd-t pd-x">
            <h1 class="txt-l mg-0 pd-y">
                <template v-if="!sxdata">{{jianfan(sxy+'年'+sext[1]+'命'+sxArr[sxi]+'下半年运程')}}</template>
                <template v-else>{{jianfan(sxdata.title)}}</template>
            </h1>
        </div>
        <van-skeleton title avatar :row="19" :loading="loading">
            <van-tabs
                v-if="!loading"
                class="sxlm-wrap"
                ref="sxlm"
                v-model="tabi"
                background="none"
                :border="false"
                title-inactive-color="#FFFFFF"
                title-active-color="#FFFF99"
                scrollspy
                sticky
            >
                <van-tab class="lm-wrap yc-data" :title="jianfan('运程图解')">
                    <div class="flex-x sx-hdbar pd-t">
                        <div class="fe-full flex fe-m fe-c">
                            <van-button
                                type="warning"
                                icon="good-job-o"
                                @click="showStar = !showStar"
                            >{{jianfan("明星推荐")}}</van-button>
                        </div>
                        <div class="fe-m">
                            <van-image
                                round
                                width="4rem"
                                height="4rem"
                                :src="sxObj[sxi]['img']"
                                @click="sxSwitch=true"
                            />
                        </div>
                        <div class="fe-full flex fe-m fe-c">
                            <van-button
                                type="warning"
                                icon="exchange"
                                @click="sxSwitch=true"
                            >{{jianfan('生肖切换')}}</van-button>
                        </div>
                    </div>
                    <!-- <div class="flex-x fe-c">
                        <div class="pd-r">
                            <router-link :to="{path:'/sx', query:{sxi,sex:1,sxy}}">
                                <van-button
                                    :type="sex==1?'warning':'default'"
                                    size="small"
                                    plain
                                    hairline
                                >男命</van-button>
                            </router-link>
                            <router-link :to="{path:'/sx', query:{sxi,sex:0,sxy}}">
                                <van-button
                                    :type="sex==0?'warning':'default'"
                                    size="small"
                                    plain
                                    hairline
                                >女命</van-button>
                            </router-link>
                        </div>
                        <div class="pd-l">
                            <router-link :to="{path:'/sx', query:{sxi,sex,sxy}}">
                                <van-button
                                    :type="fot!='fanti'?'warning':'default'"
                                    size="small"
                                    plain
                                    hairline
                                >简体</van-button>
                            </router-link>
                            <router-link :to="{path:'/sx', query:{sxi,sex,sxy,fot:'fanti'}}">
                                <van-button
                                    :type="fot=='fanti'?'warning':'default'"
                                    size="small"
                                    plain
                                    hairline
                                >繁体</van-button>
                            </router-link>
                        </div>
                    </div> -->
                    <div class="pds-a">
                        <div
                            class="zb-bar flex-x"
                            :class="zb.val[2][1]=='吉'?'zb-ji':'zb-xo'"
                            v-for="(zb,i) in sxdata['zbdata'][sxi]['zb']"
                            :key="i"
                            @click="toLanmu('开运指标', i)"
                        >
                            <div class="zb-hd fe-m">
                                <strong class="zb-fix zbtxt">{{zb.val[0]}}</strong>
                                <small class="zb-fix zbjx">{{zb.val[2][1]}}</small>
                            </div>
                            <div class="bar-box fe-full fe-m">
                                <span class="tips">{{zb.val[1]}}</span>
                                <van-progress
                                    :percentage="zb.val[3]"
                                    :pivot-text="zb.val[3]+'分'"
                                    :color="zb.val[2][1]=='吉'?'#ff4040':'#000'"
                                    stroke-width="18"
                                />
                            </div>
                            <div class="flex fe-m mgs-l">
                                <van-button
                                    :color="zb.val[2][1]=='吉'?'#ff4040':'#000'"
                                    size="mini"
                                >查看</van-button>
                            </div>
                        </div>
                    </div>
                    <div class="txt-c txt-gray pd-b">{{jianfan('提示：点击详情可查看运势详解！')}}</div>
                </van-tab>
                <van-tab class="lm-wrap" :title="jianfan('生肖总运')">
                    <div class="lmtit">{{jianfan(sxy+'年'+sexz+'命生肖'+sxArr[sxi]+'下半年运程')}}</div>
                    <van-tabs v-model="tabc['生肖总运']" animated swipeable>
                        <van-tab v-for="(vo,i) in sxdata.zhong" :title="vo.title||''" :key="i">
                            <div class="lmbox" v-html="vo.item[sxy]"></div>
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <van-tab class="lm-wrap" :title="jianfan('下半年运程')">
                    <div class="lmtit">{{sxdata.title}}</div>
                    <van-tabs v-model="tabc['下半年运程']" animated swipeable>
                        <van-tab v-for="(vo,i) in sxdata['xiangxi']" :title="vo.title||''" :key="i">
                            <div class="lmbox" v-html="vo.item[sxy]||'数据读取失败！'"></div>
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <van-tab class="lm-wrap" :title="jianfan('三大主运')">
                    <div class="lmtit">{{jianfan('三大主运开启')}}</div>
                    <van-tabs v-model="tabc['三大主运']" animated swipeable>
                        <van-tab v-for="(vo,i) in sxdata['kaiqi']" :title="vo.title||'-'" :key="i">
                            <div class="lmbox" v-html="vo.item[sxy]||'数据读取失败！'"></div>
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <van-tab class="lm-wrap" :title="jianfan('下半年指南')">
                    <div class="lmtit">{{jianfan('下半年开运指南')}}</div>
                    <div class="lmbox" v-html="sxdata['zhinan']['item'][sxy]||'数据读取失败！'"></div>
                </van-tab>

                <van-tab class="lm-wrap" :title="jianfan('运程视频')">
                    <div class="lmtit">{{jianfan(sext[1]+'命生肖'+sxArr[sxi]+'运程视频')}}</div>
                    <video-player :sxi="sxi" :sex="sex"></video-player>
                </van-tab>
                <van-tab class="lm-wrap" :title="jianfan('智德经验')">
                    <div class="lmtit">{{sxdata.jingyan.title||''}}</div>
                    <div class="lmbox" v-html="sxdata.jingyan.desc"></div>
                </van-tab>

                <van-tab class="lm-wrap" :title="jianfan('开运指标')">
                    <div class="lmtit">{{sxdata.zhibiao.title||''}}</div>
                    <van-tabs v-model="tabc['开运指标']" animated swipeable>
                        <van-tab
                            v-for="(vo,i) in sxdata['zhibiao']['item']"
                            :title="vo.title[0]||'-'"
                            :key="i"
                        >
                            <div class="lmbox" v-html="vo.desc"></div>
                        </van-tab>
                    </van-tabs>
                </van-tab>

                <van-tab class="lm-wrap star-cmd" title="明星推荐">
                  <div class="lmtit">{{jianfan('明星推荐')}}</div>
                  <div class="pds-a">
                    <van-row type="flex">
                      <van-col span="24">
                        <a href="https://www.qixingtang.com/xinwen/view-4.html" target="_blank">
                          <img src="../assets/img/mx_01.jpg" />
                        </a>
                      </van-col>
                    </van-row>
                    <van-row type="flex" gutter="4">
                      <van-col span="8">
                        <a href="https://www.qixingtang.com/xinwen/view-4.html" target="_blank">
                          <img src="../assets/img/mx_02.jpg" />
                        </a>
                      </van-col>
                      <van-col span="8">
                        <a href="https://www.qixingtang.com/xinwen/view-5.html" target="_blank">
                          <img src="../assets/img/mx_03.jpg" />
                        </a>
                      </van-col>
                      <van-col span="8">
                        <a href="https://www.qixingtang.com/xinwen/view-7.html" target="_blank">
                          <img src="../assets/img/mx_04.jpg" />
                        </a>
                      </van-col>
                    </van-row>
                    <div class="pd-b">香港老牌影帝李修贤、影星何家劲、歌星黄安对智德师傅徐墨斋父子大加赞扬。</div>
                  </div>
                </van-tab>
                <van-tab class="lm-wrap" :title="jianfan('生肖改运')">
                    <div class="lmtit">{{sxdata.goods.title||''}}</div>
                    <van-tabs v-model="tabc['生肖改运']" animated swipeable>
                        <van-tab
                            v-for="(vo,i) in sxdata.goods.item"
                            :title="vo.title.substr(0,4)||'-'"
                            :key="i"
                        >
                            <van-card
                                class="txt-l"
                                :num="1"
                                :price="sxdata['sxgoods'][i]['price']"
                                :desc="sxdata['sxgoods'][i]['intro']"
                                :title="sxdata['sxgoods'][i]['title']"
                                :thumb="goodsImg[i]"
                            >
                                <template #tags>
                                    <van-tag
                                        class="mgs-r"
                                        plain
                                        type="danger"
                                        v-for="(tag,ti) in sxdata['sxgoods'][i]['tags']"
                                        :key="ti"
                                    >{{tag}}</van-tag>
                                </template>
                                <template #footer>
                                    <van-button
                                        size="small"
                                        type="primary"
                                        :url="'https://www.qixingtang.com/show-'+sxdata['sxgoods'][i]['id']+'.html'"
                                    >查看详情</van-button>
                                </template>
                            </van-card>
                            <div class="lmbox" v-html="vo.desc"></div>
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <van-tab class="lm-wrap" :title="jianfan('智德推荐')">
                    <div class="lmtit">{{jianfan('智德师傅推荐吉祥物')}}</div>
                    <van-tabs v-model="tabc['智德推荐']" animated swipeable>
                        <van-tab v-for="(vo,i) in zdcmd" :title="vo" :key="i">
                            <div class="flex-x">
                                <a
                                    v-for="k in 3"
                                    :key="k"
                                    :href="'https://www.qixingtang.com/show-'+(sxdata.keygoods[i*3+k-1]['id'])+'.html'"
                                    target="blank"
                                    class="fe-full mgs-a"
                                >
                                    <!-- (i*3)+k-1 -->
                                    <van-image :src="sxdata.keygoods[i*3+k-1]['img']" />
                                    <div
                                        class="van-ellipsis txt-d-orange txt-bold"
                                    >{{sxdata.keygoods[i*3+k-1].title}}</div>
                                    <small class="van-ellipsis txt-gray">{{sxdata.keygoods[i*3+k-1]['txt']}}</small>
                                </a>
                            </div>
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <van-tab class="lm-wrap" :title="jianfan('五求开运')">
                    <div class="lmtit">{{sxdata.wuqiu.title||''}}</div>
                    <van-tabs v-model="tabc['五求开运']" animated swipeable>
                        <van-tab v-for="(vo,i) in sxdata.wuqiu.item" :title="vo.title" :key="i">
                            <div class="lmbox" v-html="vo.desc"></div>
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <van-tab class="lm-wrap" :title="jianfan('八凶化解')">
                    <div class="lmtit">{{sxdata.bafang.title||''}}</div>
                    <van-tabs v-model="tabc['八凶化解']" animated swipeable>
                        <van-tab v-for="(vo,i) in sxdata.bafang.item" :title="vo.title" :key="i">
                            <div class="lmbox" v-html="vo.desc"></div>
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <!-- <van-tab class="lm-wrap" :title="jianfan('生肖年份')" v-if="sxdata.meinian.item[sxy]">
          <div class="lmtit">{{sxdata.meinian.item[sxy].title||''}}</div>
          <van-tabs v-model="tabc['生肖年份']" animated swipeable>
            <van-tab
              v-for="(vo,i) in sxdata.meinian.item[sxy].desc.desc"
              :title="sxdata.meinian.item[sxy].desc.title[i]||'-'"
              :key="i"
            >
              <div class="lmbox" v-html="vo"></div>
            </van-tab>
          </van-tabs>
                </van-tab>-->
                <!-- <van-tab class="lm-wrap" :title="jianfan('好运集锦')">
          <div class="lmtit">{{sxdata.haoyun.title||''}}</div>
          <div class="lmbox" v-html="sxdata.haoyun.desc"></div>
                </van-tab>-->
                <van-tab class="lm-wrap" :title="jianfan('八大人群')">
                    <div class="lmtit">{{sxdata.renqun.title||''}}</div>
                    <van-tabs v-model="tabc['八大人群']" animated swipeable>
                        <van-tab
                            v-for="(vo,i) in sxdata.renqun.item"
                            :title="vo.title.substr(0,4)"
                            :key="i"
                        >
                            <div class="lmbox" v-html="vo.desc"></div>
                        </van-tab>
                    </van-tabs>
                </van-tab>

                <van-tab class="lm-wrap" :title="jianfan('整年诊断')">
                    <div class="lmtit">{{sxdata.zhennian.title||''}}</div>
                    <van-tabs v-model="tabc['整年诊断']" animated swipeable>
                        <van-tab
                            v-for="(vo,i) in sxdata.zhennian.item"
                            :title="vo.title.substr(0,4)||'-'"
                            :key="i"
                        >
                            <div class="lmbox" v-html="vo.desc"></div>
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <van-tab class="lm-wrap" :title="jianfan('流月运势')">
                    <div class="lmtit">{{sxdata.liuyue.title||''}}</div>
                    <van-tabs v-model="tabc['流月运势']" animated swipeable>
                        <van-tab v-for="(vo,i) in sxdata.liuyue.item" :title="(i+1)+'月'" :key="i">
                            <div class="lmbox" v-html="vo"></div>
                        </van-tab>
                    </van-tabs>
                </van-tab>
            </van-tabs>
        </van-skeleton>
        <!-- 生肖切换 -->
        <van-popup
            v-model="sxSwitch"
            :style="{ width:'90%',maxWidth:'320px',height: 'auto', borderRadius:'0.2rem' }"
            class="sx-pop"
            close-icon="close"
            closeable
        >
            <sx-grid></sx-grid>
        </van-popup>
        <!-- 明星推荐 -->
        <star-cmd :show="showStar"></star-cmd>
        <!-- 脚注 -->
        <sx-footer></sx-footer>
        <!-- 测栏工具 -->
        <div class="tools" v-show="tabi">
            <div class="icons" @click="dsShow = !dsShow">
                <van-image :src="dashiImg"></van-image>
                <div class="text">算八字</div>
            </div>
            <div class="icons" @click="sxSwitch = true">
                <van-icon name="apps-o" class="mgs-t" />
                <div class="text">换生肖</div>
            </div>
            <div class="icons" @click="toLanmu(0)">
                <van-icon name="home-o" class="mgs-t" />
                <div class="text">回顶部</div>
            </div>
        </div>
        <!-- 二维码 -->
        <div class="qr-code">
            <van-image :src="qrcode" width="164" />
            <div class="flex-x fe-m fe-c txt-d-orange pd-b">
                <div class="flex fe-m">
                    <van-icon name="scan" :style="{fontSize:'2.6em'}" />
                </div>
                <div>
                    手机扫码
                    <br />体验更佳
                </div>
            </div>
        </div>
        <!-- 在线师傅 -->
        <dashi :show="dsShow"></dashi>
    </div>
</template>

<script>
import videoPlayer from "../components/video-player";
import starCmd from "../components/star-cmd";
import sxFooter from "../components/sx-footer";
import dashi from "../components/dashi";

import QRCode from "qrcode";
import axios from "../axios";
import { toFan } from "../utils/jianfan";

import { mapState, mapGetters } from "vuex";
import sxGrid from "../components/sx-grid";
//import axios from './axios'
//import { mapGetters } from 'vuex'
export default {
    name: "index",
    components: { videoPlayer, sxGrid, starCmd, sxFooter, dashi },
    data() {
        return {
            loading: true,
            params: this.$route.query,
            showStar: false,
            sxVideo: "",
            sxdata: null,
            qrcode: null,
            dsShow: false,
            curpath: "",

            tabi: 0, //主导航
            tabc: {}, //栏目导航
            tabsort: [], //栏目排序
            sxSwitch: false, //生肖切换POP
            sxi: this.$route.query.sxi,     //生肖ID
            sex: this.$route.query.sex,     //性别
            sxy: this.$route.query.sxy,     //生肖年
            fot: this.$route.query.fot,     //简繁
            zdcmd: ["健康", "招财", "事业", "家庭", "子女"],

            goodsImg: [],
            dashiImg: require("../assets/img/tx_zhide.jpg")
        };
    },
    computed: {
        ...mapState(["sxArr", "sexArr", "datas", "sellid"]),
        ...mapGetters(["sxObj"]),
        //生肖汉字
        sxz() {
            return this.sxArr[this.sxi];
        },
        //性别汉字
        sexz() {
            return this.sex == 1 ? "男" : "女";
        },
        sext() {
            return this.sexArr[this.sex];
        }
    },
    mounted() {
        //自动简繁
        if (!this.fot && navigator.language != "zh-CN") {
            this.fot = "fanti";
        }
        //qrCode
        QRCode.toDataURL(location.href).then(url => {
            this.qrcode = url;
        });
        //读取页面
        this.loadPage();
        this.curpath = this.sxi + "-" + this.sex;
        //生肖产品
        this.goodsImg = [
            require('../assets/img/thumb/'+this.sext[0]+'/gj_'+this.sxi+'.jpg'),
            require('../assets/img/thumb/'+this.sext[0]+'/bj_'+this.sxi+'.jpg')
        ];
        /* this.sexArr.forEach((sex)=>{
            this.sxArr.forEach((item,i)=>{
                goodsImg[sex[0]][i] = [
                    require('../assets/img/thumb/'+sex[0]+'/gj_'+i+'.jpg'),
                    require('../assets/img/thumb/'+sex[0]+'/bj_'+i+'.jpg')
                ]
            })
        }) */
        
    },
    beforeRouteUpdate(to, from, next) {
        //console.log("beforeRouteUpdate");
        //this.loading = true
        this.sxi = to.query.sxi;
        this.sex = to.query.sex;
        this.sxy = to.query.sxy;
        this.fot = to.query.fot;

        let curpath = this.sxi + "-" + this.sex;
        if (this.curpath != curpath) {
            //读取页面
            this.loadPage();
            this.curpath = curpath;
        }

        next();
    },
    methods: {
        //跳转到栏目及其选项卡
        toLanmu(name, tabi) {
            let $tabs = this.$refs.sxlm;
            let lmi =
                name >= 0 ? name : this.tabsort.findIndex(item => item == name);
            $tabs.setCurrentIndex(lmi);
            $tabs.scrollToCurrentContent(tabi);
            //子选项卡
            if (tabi >= 0) {
                let $child = $tabs.children[lmi].$children[0];
                $child.setCurrentIndex(tabi);
                $child.scrollToCurrentContent();
            }
        },
        //初始化页面
        loadPage() {
            const that = this;
            //this.loading = true
            this.sxSwitch = false;
            let sxi = this.sxi;
            let sex = this.sex;
            let sxy = this.sxy;
            //Loading
            this.$toast({
                overlay: true,
                type: "loading",
                message: "正在加载..."
            });
            axios
                .get("/2020js/jianti_" + sxi + "_" + sex + ".js", {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                })
                .then(sxdata => {
                    this.$toast.clear();
                    that.loading = false;
                    sxdata.title =
                        sxy +
                        "年" +
                        this.sext[1] +
                        "命" +
                        this.sxArr[sxi] +
                        "下半年运程";
                    //转繁体
                    sxdata = this.jianfan(sxdata);
                    //连接添加Sellid
                    if (this.sellid) {
                        sxdata = this.linksAttr(sxdata);
                    }
                    //加载图片
                    sxdata.keygoods.forEach((item,i)=>{
                        item.img = require('../assets/img/oth/'+item.id+'.jpg')
                        sxdata.keygoods[i] = item
                    })
                    //console.log("sxdata", sxdata);

                    document.title = sxdata.title;
                    this.sxdata = sxdata;
                    this.$nextTick(() => {
                        //遍历栏目
                        this.$refs.sxlm &&
                            this.$refs.sxlm.children.forEach(elm => {
                                this.tabc[elm.title] = 0;
                                this.tabsort.push(elm.title);
                            });
                        //console.log("栏目排序", this.tabsort);
                    });
                });
        },
        jianfan(data) {
            if (this.fot == "fanti") {
                data = toFan(data);
            }
            return data;
        },
        // 连接添加sellid
        linksAttr(data) {
            let type = Object.prototype.toString.call(data);
            if (
                type == "[object Object]" || type == "[object Array]"
                    ? true
                    : false
            ) {
                for (var key in data) {
                    data[key] = this.linksAttr(data[key]);
                }
                return data;
            } else if (typeof data == "string") {
                var reg = new RegExp('href="(.+?)"', "gmi");
                data = data.replace(
                    reg,
                    'href="$1?sellid=' + this.sellid + '"'
                );
                return data;
            } else {
                return data;
            }
        }
    }
};
</script>

<style>
.sx-pop .van-icon-close {
    position: absolute;
    right: 0;
    top: 0;
    background: #900;
    color: #fff;
    padding: 3px;
    border-radius: 100%;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
}
</style>